import { render } from "./BotFAQs.vue?vue&type=template&id=6e153ef9&scoped=true"
import script from "./BotFAQs.vue?vue&type=script&lang=js"
export * from "./BotFAQs.vue?vue&type=script&lang=js"

import "./BotFAQs.vue?vue&type=style&index=0&id=6e153ef9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e153ef9"]])

export default __exports__